import React from 'react';
import { Box, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import OrderListViewStore from '@components/order/stores/OrderListViewStore';
import OrderListItemAddress from '../OrderListItemAddress';
import LocationOnTwoToneIcon from '@mui/icons-material/LocationOnTwoTone';
import PaidTwoToneIcon from '@mui/icons-material/PaidTwoTone';
import Amount from '@components/common/molecules/Amount';

interface OrderInfoProps {
    orderListViewStore: OrderListViewStore;
}

const OrderInfo: React.FC<OrderInfoProps> = ({ orderListViewStore }) => {
    const { orderRepeatContainer } = orderListViewStore;
    if (orderRepeatContainer === undefined) {
        return null;
    }

    const { orderOriginal } = orderRepeatContainer;
    return (
        <Box mb={1}>
            <ListItem>
                <ListItemIcon>
                    <LocationOnTwoToneIcon fontSize='large' />
                </ListItemIcon>
                <ListItemText
                    primary={<OrderListItemAddress order={orderOriginal} variant='body1' />}
                    secondary={orderOriginal.locationDescription} />
            </ListItem>

            <ListItem>
                <ListItemIcon>
                    <PaidTwoToneIcon fontSize='large' />
                </ListItemIcon>
                <ListItemText
                    primary={<Amount amount={orderOriginal.totalAmount} fontWeight={600} />}
                    secondary={orderOriginal.deliveryFee} />
            </ListItem>
        </Box>
    )
}

export default OrderInfo;